import React from 'react';
import './reviewAll.css';

export default props => {
  const { isFleek = false } = props;
  return (
    <div className={`review-details ${isFleek && 'review-details-fleek'}`}>
      <div className="shimmer_lines star-text">
        <div className={`star-box ${isFleek && 'box-fleek'}`} />
        <div className={`text-box ${isFleek && 'box-fleek'}`} />
      </div>
      <div className={`shimmer_lines text-line2 ${isFleek && 'box-fleek'}`} />
      <div className="shimmer_lines photos">
        <div className={`photo-box ${isFleek && 'box-fleek'}`} />
        <div className={`photo-box ${isFleek && 'box-fleek'}`} />
      </div>
      <div className="shimmer_lines posted-details">
        <div className={`shimmer-name ${isFleek && 'box-fleek'}`} />
        <div className={`shimmer-verified ${isFleek && 'box-fleek'}`} />
        <div className={`shimmer-verified-text ${isFleek && 'box-fleek'}`} />
      </div>
      <div className={`shimmer_lines posted-date ${isFleek && 'box-fleek'}`} />
      <div className="shimmer_lines helpful-box">
        <div className={`like-number ${isFleek && 'box-fleek'}`} />
        <div className={`like-text ${isFleek && 'box-fleek'}`} />
        <div className={`mark-helpful ${isFleek && 'box-fleek'}`} />
      </div>
      <div className="shimmer_lines star-text mt-3">
        <div className={`star-box ${isFleek && 'box-fleek'}`} />
        <div className={`text-box ${isFleek && 'box-fleek'}`} />
      </div>
      <div className={`shimmer_lines text-line2 ${isFleek && 'box-fleek'}`} />
      <div className="shimmer_lines photos">
        <div className={`photo-box ${isFleek && 'box-fleek'}`} />
        <div className={`photo-box ${isFleek && 'box-fleek'}`} />
      </div>
      <div className="shimmer_lines posted-details">
        <div className={`shimmer-name ${isFleek && 'box-fleek'}`} />
        <div className={`shimmer-verified ${isFleek && 'box-fleek'}`} />
        <div className={`shimmer-verified-text ${isFleek && 'box-fleek'}`} />
      </div>
      <div className={`shimmer_lines posted-date ${isFleek && 'box-fleek'}`} />
      <div className="shimmer_lines helpful-box">
        <div className={`like-number ${isFleek && 'box-fleek'}`} />
        <div className={`like-text ${isFleek && 'box-fleek'}`} />
        <div className={`mark-helpful ${isFleek && 'box-fleek'}`} />
      </div>
      <div className="shimmer_lines star-text mt-3">
        <div className={`star-box ${isFleek && 'box-fleek'}`} />
        <div className={`text-box ${isFleek && 'box-fleek'}`} />
      </div>
      <div className={`shimmer_lines text-line2 ${isFleek && 'box-fleek'}`} />
      <div className="shimmer_lines photos">
        <div className={`photo-box ${isFleek && 'box-fleek'}`} />
        <div className={`photo-box ${isFleek && 'box-fleek'}`} />
      </div>
      <div className="shimmer_lines posted-details">
        <div className={`shimmer-name ${isFleek && 'box-fleek'}`} />
        <div className={`shimmer-verified ${isFleek && 'box-fleek'}`} />
        <div className={`shimmer-verified-text ${isFleek && 'box-fleek'}`} />
      </div>
      <div className={`shimmer_lines posted-date ${isFleek && 'box-fleek'}`} />
      <div className="shimmer_lines helpful-box">
        <div className={`like-number ${isFleek && 'box-fleek'}`} />
        <div className={`like-text ${isFleek && 'box-fleek'}`} />
        <div className={`mark-helpful ${isFleek && 'box-fleek'}`} />
      </div>
    </div>
  );
};
